import { Loader } from "@sazka/design-system/src/loader/loader";
import { NgOpenPageRequest, NgGamesLobbyOpenPage } from "@sazka/ng/model/ng-open-page-request";
import { NgOpenPageResponse } from "@sazka/ng/model/ng-open-page-response";
import { showGameHelpPopup } from "@sazka/ng/ng-game-help";
import { useRgLimitsPopup } from "@sazka/ng/rg-limits/use-rg-limits-popup";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { useGdpr } from "@/shared/gdpr/use-gdpr";

export async function ngOpenPage(key: string, customInfo: string | any) {
    // total fallback
    let url: string = null;
    // eslint-disable-next-line
    let blank = false;
    key = typeof key === "string" ? key.toLowerCase() : key;
    customInfo = typeof customInfo === "string" ? customInfo.toLowerCase() : customInfo;

    // ignore solo gameslobby - it happens when user recarges money and then clicks "Zpět do nabídky her"
    // in this case user can miss screen "your bet has been placed"
    if (key === "gameslobby" && !customInfo) return;

    switch (key) {
        // ticket detail from NG's popups
        case "externalbetdetails":
            url = "/moje-sazky/detail/" + customInfo.GameInstanceID;
            break;

        // Shows game help popups
        case "helpgame":
            showGameHelpPopup(customInfo);
            return;

        // preference center - PRC
        case "preferencecenter":
            url = await useGdpr().getLinkToPrefCenter();
            blank = true;
            break;

        case "rglimits":
            const { showRgPopup } = useRgLimitsPopup();
            await showRgPopup();
            ng_fw.closeMyAccount();
            return;

        default:
            Loader.show();
            try {
                const response = await httpClient.get<NgOpenPageResponse>("/api/ng/open-page", {
                    params: makeRequest(key, customInfo),
                });
                url = response.data.url;
                blank = response.data.openMode === "new";
            } catch (error) {
                console.error(error);
            }
    }

    if (!url) {
        // default
        url = "/centrum-podpory";
    }

    if (blank) {
        Loader.hide();
    }

    window.open(url, blank ? "_blank" : "_self");
}

function makeRequest(
    key: string,
    customInfo: string | Record<string, string> | NgGamesLobbyOpenPage
): NgOpenPageRequest {
    if (key == "gameslobby") {
        const info = customInfo as NgGamesLobbyOpenPage;
        return {
            key: key,
            verticals: info.verticals.join("|"),
            provider: info.provider?.toLowerCase(),
            subProvider: info.subprovider?.toLowerCase(),
        };
    } else if (key == "playerlimitedaccess") {
        return {
            key,
        };
    } else {
        return {
            key,
            info: customInfo?.toString(),
        };
    }
}
